// extracted by mini-css-extract-plugin
module.exports = {"container":"i_eS","ios":"i_eT","android":"i_eU","exit":"i_eV","image":"i_eW","info":"i_eX","button":"i_eY","label":"i_eZ","title":"i_ea","author":"i_eb"};